import { ABTastyLogo, ABTastyLogoFormats, IconV2, Tooltip } from '@abtasty/design-system';
import {
  MSG_NAME_FROM_IFRAME,
  MSG_NAME_TO_IFRAME,
  sendMessageFromIframe,
  sendMessageToIframe,
} from '@src/container/handleIframeMessage/handleIframeMessage';
import { useSegmentTrack } from '@application/hooks/useSegment/useSegment';
import { useTranslation } from 'react-i18next';
import styles from './Logo.module.scss';
import { useHasMediaHover } from '@src/application/hooks/useHasMediaHover';

export function Logo() {
  const { t } = useTranslation();
  const segmentTrack = useSegmentTrack();
  // To avoid sticky hover effect on touch devices
  const hasHover = useHasMediaHover();
  return (
    <Tooltip content={hasHover ? t('Minimize') : undefined} placement="bottom" type="small">
      <div data-testid="logo" className={styles.logoContainer}>
        <div className={styles.minimize}>
          <IconV2
            size={24}
            icon="resizeMinimize"
            color="white"
            onClick={() => {
              segmentTrack('Qa - Click minimize');
              sendMessageFromIframe({ name: MSG_NAME_FROM_IFRAME.QaAssistantCollapse, value: true });
              sendMessageToIframe({ name: MSG_NAME_TO_IFRAME.QaAssistantCollapse, value: true });
            }}
          />
        </div>
        <ABTastyLogo format={ABTastyLogoFormats.AB_ROUND_OPENED_2024} width="32" height="32" />
      </div>
    </Tooltip>
  );
}
